import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const strengths = [
  {
    icon: 'ri-heart-3-line',
    title: '痛くないから安心',
    desc: '体を優しくなでるような刺激で、心も体もフワッと軽くなります。「整体って怖そう…」というイメージを覆す、赤ちゃんに触れるような施術です。',
  },
  {
    icon: 'ri-refresh-line',
    title: '脳をリラックスさせる',
    desc: '自律神経の「アクセル」と「ブレーキ」のバランスを整えます。脳がリラックスすると、体は自然と「回復モード」に切り替わります。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '再発しにくい体づくり',
    desc: 'あなた自身の「治ろうとする力」を引き出します。症状を一時的に抑えるのではなく、根本から体質を改善していきます。',
  },
];

const strengthDelays = ['delay-2', 'delay-3', 'delay-4'];

export default function SolutionSection() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section id="solution" className="bg-clinic-cream py-16 md:py-24">
      <div ref={ref} className={`w-full px-4 md:px-8 max-w-5xl mx-auto scroll-reveal ${isVisible ? 'visible' : ''}`}>
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-serif text-xl md:text-3xl font-bold text-clinic-dark mb-3 scroll-reveal-item delay-1">
            バキバキしない、赤ちゃんに触れるような
            <br />
            優しい整体です
          </h2>
          <p className="text-clinic-gray text-sm md:text-base max-w-2xl mx-auto leading-relaxed scroll-reveal-item delay-1">
            「整体って怖そう…」そんなイメージがあるかもしれません。
            <br className="hidden md:block" />
            当院の施術は、脳から「安心ホルモン」がたっぷり出るように、優しく体に触れるだけの特別な方法です。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {strengths.map((item, index) => (
            <div key={index} className={`bg-white rounded-xl p-6 md:p-8 shadow-sm scroll-reveal-item ${strengthDelays[index]}`}>
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-clinic-green-light mb-5">
                <i className={`${item.icon} text-clinic-green text-xl md:text-2xl`} />
              </div>
              <h3 className="font-bold text-clinic-dark text-base md:text-lg mb-3">{item.title}</h3>
              <p className="text-clinic-gray text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}